export const URL_PARAMS = {
  x: 'canvas_x',
  y: 'canvas_y',
  s: 'canvas_scale',
} as const;
